/**
 * Error Boundary Component
 * Catches JavaScript errors in child components
 */
import React from 'react';
import { ErrorPage } from '../pages/ErrorPages';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console (in production, send to logging service)
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // Could send to backend logging endpoint here
    // fetch('/api/log-error', { method: 'POST', body: JSON.stringify({ error: error.message, stack: error.stack }) });
  }

  resetError = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return <ErrorPage error={this.state.error} resetError={this.resetError} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
